// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3TXL6","calendarButtons":"ClockData_calendarButtons__1GPE9"};